module.exports = __webpack_public_path__ + "img/woman-illustration.30eaf356.svg";